export default __webpack_public_path__ + "static/media/orange-ellipse2.a39484a9.png";